// ТЕКСТ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ — ОДИН НА СТРАНИЦУ /privacy И НА СЛОЙ КАБИНЕТА (ТЗ ANIM-FIX О5
// П2, 04.10.2026: на телефоне «Конфиденциальность» из «Аккаунта» открывается боковым слоем, а не
// уходом на страницу). Слова документа живут здесь; страница (app/[locale]/privacy/page.tsx) и
// слой (cabinet/help-layer.tsx) рисуют их в одном каркасе LegalShell.
import { LEGAL_EMAIL } from './legal-shell';

/** Название и редакция документа — шапка страницы и слоя. */
export function privacyHead(locale: string): { title: string; updated: string } {
  return locale === 'en'
    ? { title: 'Privacy Policy', updated: 'Last updated: July 29, 2026' }
    : { title: 'Политика конфиденциальности', updated: 'Редакция от 29 июля 2026 года' };
}

/** Тело документа на языке страницы. */
export function PrivacyText({ locale }: { locale: string }) {
  return locale === 'en' ? <En /> : <Ru />;
}

const MAIL = <a href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>;

function Ru() {
  return (
    <>
      <h2>1. Введение</h2>
      <p>
        Scriptera — сервис, который собирает и запускает чат-ботов и автоматизации
        («сценарии») в Telegram, Instagram, на сайтах и в других каналах. Эта политика
        объясняет, какие персональные данные мы обрабатываем, зачем и какие у вас есть
        права. «Персональные данные» — любая информация, по которой можно определить
        конкретное лицо: имя, email, телефон, идентификатор в мессенджере. «Сервис» — сайт
        scriptera.ai с поддоменами, мобильные приложения Scriptera и созданные в них
        сценарии. Используя Сервис, вы соглашаетесь с этой политикой; обработка ведётся по
        законодательству РФ, включая 152-ФЗ «О персональных данных».
      </p>

      <h2>2. Какие данные мы собираем</h2>
      <h3>2.1. Данные, которые вы предоставляете сами</h3>
      <ul>
        <li>профиль: имя, email, номер телефона, пароль (хранится необратимо зашифрованным);</li>
        <li>
          доступы подключённых каналов: когда вы подключаете к сценарию Telegram-бота,
          аккаунт Instagram, CRM или другой сервис, мы храним выданные ими ключи доступа в
          зашифрованном виде и используем только для работы ваших сценариев;
        </li>
        <li>
          содержимое сценариев: тексты сообщений, настройки, файлы, товары, базы знаний —
          всё, что вы загружаете для работы ботов;
        </li>
        <li>обращения в поддержку и переписку с нами.</li>
      </ul>
      <h3>2.2. Данные от платформ и третьих лиц</h3>
      <p>
        Через официальные интерфейсы подключённых платформ (Telegram, Instagram и других)
        мы получаем данные, нужные для работы сценариев: идентификатор и имя вашего
        аккаунта, входящие сообщения, комментарии и упоминания, публичные данные тех,
        кто пишет вашим ботам. Данные аудитории ваших сценариев (подписчики, их
        переписка, метки, контакты) мы обрабатываем по вашему поручению — за законность их
        сбора отвечаете вы. Платёжный сервис (Робокасса) передаёт нам факт, сумму и
        назначение платежа; данные банковских карт мы не получаем и не храним.
      </p>
      <h3>2.3. Данные, собираемые автоматически</h3>
      <p>
        IP-адрес, тип браузера и устройства, язык, страницы и действия в Сервисе, журналы
        работы сценариев. Для этого используются cookies и похожие технологии.
      </p>
      <h3>2.4. Cookies</h3>
      <p>
        Необходимые cookies обеспечивают вход и работу Сервиса; настроечные запоминают язык
        и тему; аналитические помогают понимать, как Сервис используется. Cookies можно
        отключить в браузере, но часть функций перестанет работать.
      </p>

      <h2>3. Зачем мы используем данные</h2>
      <ul>
        <li>предоставлять и поддерживать Сервис и ваши сценарии;</li>
        <li>проводить платежи и вести учёт подписки;</li>
        <li>отвечать на обращения и присылать служебные уведомления;</li>
        <li>улучшать Сервис и защищать его от злоупотреблений;</li>
        <li>исполнять требования закона.</li>
      </ul>
      <p>Мы не продаём персональные данные и не используем их для сторонней рекламы.</p>

      <h2>4. Кому мы раскрываем данные</h2>
      <ul>
        <li>платёжному сервису — для проведения платежей;</li>
        <li>поставщикам инфраструктуры (хостинг, резервное копирование) — для работы Сервиса;</li>
        <li>провайдерам ИИ-моделей — в объёме раздела 6;</li>
        <li>
          платформам (Telegram, Meta и другим) — когда ваш сценарий отправляет туда данные
          по заданной вами логике;
        </li>
        <li>государственным органам — только по законному требованию.</li>
      </ul>
      <p>
        Обезличенные и агрегированные данные (без возможности определить конкретное лицо) могут
        использоваться для статистики.
      </p>

      <h2>5. Безопасность</h2>
      <p>
        Мы применяем технические и организационные меры защиты: шифрование ключей доступа,
        разграничение прав, журналирование. О происшествиях, создающих высокий риск для
        ваших прав, мы уведомляем без неоправданной задержки.
      </p>

      <h2>6. Искусственный интеллект</h2>
      <h3>6.1. Что делает ИИ</h3>
      <p>
        ИИ в Scriptera помогает собирать сценарии и отвечать вашей аудитории от имени ваших
        ботов: обрабатывает тексты, изображения и документы, которые проходят через
        сценарий.
      </p>
      <h3>6.2. Передача провайдерам моделей</h3>
      <p>
        Содержимое ИИ-запросов передаётся провайдерам моделей — Anthropic, OpenAI, Google и
        другим — по их коммерческим условиям API: данные не используются для обучения
        моделей. Мы тоже не обучаем модели на ваших данных.
      </p>
      <h3>6.3. Хранение и удаление ИИ-данных</h3>
      <p>
        История ИИ-диалогов хранится, пока активна учётная запись; технические журналы
        ИИ-операций — до 90 дней. Удаление — по процедурам раздела 7.
      </p>

      <h2>7. Ваши права и удаление данных</h2>
      <p>
        Вы вправе узнать, какие данные о вас мы обрабатываем, исправить их, удалить, а
        также отозвать согласие на обработку. Напишите на {MAIL} с адреса учётной записи —
        ответим в срок до 10 рабочих дней.
      </p>
      <ul>
        <li>
          <strong>Удаление учётной записи:</strong> данные удаляются в течение 30 дней,
          резервные копии — в течение 90 дней.
        </li>
        <li>
          <strong>Выборочное удаление:</strong> можно удалить отдельные данные (например,
          историю ИИ-диалогов или данные конкретного подписчика) без удаления учётной
          записи.
        </li>
        <li>
          <strong>Отключение канала:</strong> при отключении Instagram, Telegram или
          другого сервиса выданные ими ключи доступа удаляются сразу.
        </li>
      </ul>
      <p>
        Пошаговая инструкция — на странице{' '}
        <a href="/ru/data-deletion">«Удаление данных»</a>. Если вы подписчик чужого бота,
        собранного в Scriptera, — обратитесь к владельцу бота или напишите нам.
      </p>

      <h2>8. Где обрабатываются данные</h2>
      <p>
        Основные данные хранятся на наших серверах. Отдельные операции (например,
        ИИ-запросы) могут обрабатываться провайдерами за пределами вашей страны — с
        применением предусмотренных законом мер защиты.
      </p>

      <h2>9. Дети</h2>
      <p>
        Сервис предназначен для лиц старше 18 лет. Узнав, что собрали данные ребёнка, мы
        незамедлительно их удалим.
      </p>

      <h2>10. Изменения политики</h2>
      <p>
        Мы можем обновлять политику; новая редакция публикуется на этой странице с датой
        обновления. О существенных изменениях сообщим в Сервисе или на почту. Продолжение
        использования Сервиса означает согласие с новой редакцией.
      </p>

      <h2>11. Вопросы</h2>
      <p>По вопросам обработки данных пишите на {MAIL}.</p>
    </>
  );
}

function En() {
  return (
    <>
      <h2>1. Introduction</h2>
      <p>
        Scriptera is a service that builds and runs chatbots and automations
        (&quot;scenarios&quot;) in Telegram, Instagram, on websites and in other channels.
        This policy explains what personal data we process, why, and what rights you have.
        &quot;Personal data&quot; is any information that can identify an individual: name,
        email, phone number, messenger ID. The &quot;Service&quot; is scriptera.ai with its
        subdomains, the Scriptera mobile apps and the scenarios built with them. By using
        the Service you agree to this policy.
      </p>

      <h2>2. Information we collect</h2>
      <h3>2.1. Information you provide</h3>
      <ul>
        <li>profile: name, email, phone number, password (stored irreversibly hashed);</li>
        <li>
          connected channel credentials: when you connect a Telegram bot, an Instagram
          account, a CRM or another service to a scenario, we store the access keys they
          issue in encrypted form and use them only to run your scenarios;
        </li>
        <li>
          scenario content: message texts, settings, files, products, knowledge bases —
          everything you upload for your bots to work;
        </li>
        <li>support requests and correspondence with us.</li>
      </ul>
      <h3>2.2. Information from platforms and third parties</h3>
      <p>
        Via the official APIs of connected platforms (Telegram, Instagram and others) we
        receive the data needed to run scenarios: your account ID and name, incoming
        messages, comments and mentions, and public data of those who message your bots.
        We process your scenarios&apos; audience data (subscribers, their chats, tags,
        contacts) on your behalf — you are responsible for collecting it lawfully. The
        payment provider passes us the fact, amount and purpose of a payment; we never
        receive or store card details.
      </p>
      <h3>2.3. Information collected automatically</h3>
      <p>
        IP address, browser and device type, language, pages and actions in the Service,
        scenario logs. Cookies and similar technologies are used for this.
      </p>
      <h3>2.4. Cookies</h3>
      <p>
        Essential cookies enable sign-in and the Service itself; preference cookies
        remember language and theme; analytics cookies help us understand how the Service
        is used. You can disable cookies in your browser, but some features will stop
        working.
      </p>

      <h2>3. How we use data</h2>
      <ul>
        <li>to provide and maintain the Service and your scenarios;</li>
        <li>to process payments and manage subscriptions;</li>
        <li>to respond to requests and send service notifications;</li>
        <li>to improve the Service and protect it from abuse;</li>
        <li>to comply with the law.</li>
      </ul>
      <p>We do not sell personal data and do not use it for third-party advertising.</p>

      <h2>4. Who we disclose data to</h2>
      <ul>
        <li>the payment provider — to process payments;</li>
        <li>infrastructure providers (hosting, backups) — to operate the Service;</li>
        <li>AI model providers — to the extent of section 6;</li>
        <li>
          platforms (Telegram, Meta and others) — when your scenario sends data there under
          the logic you configured;
        </li>
        <li>public authorities — only upon a lawful request.</li>
      </ul>
      <p>
        De-identified, aggregated data (that cannot identify an individual) may be used for
        statistics.
      </p>

      <h2>5. Security</h2>
      <p>
        We apply technical and organisational safeguards: encryption of access keys, access
        control, logging. We notify about incidents posing a high risk to your rights
        without undue delay.
      </p>

      <h2>6. Artificial intelligence</h2>
      <h3>6.1. What the AI does</h3>
      <p>
        AI in Scriptera helps build scenarios and reply to your audience on behalf of your
        bots: it processes the texts, images and documents that pass through a scenario.
      </p>
      <h3>6.2. Transmission to model providers</h3>
      <p>
        The content of AI requests is transmitted to model providers — Anthropic, OpenAI,
        Google and others — under their commercial API terms: the data is not used to train
        their models. We do not train models on your data either.
      </p>
      <h3>6.3. AI data retention and deletion</h3>
      <p>
        AI conversation history is kept while the account is active; technical AI operation
        logs — up to 90 days. Deletion follows the procedures in section 7.
      </p>

      <h2>7. Your rights and data deletion</h2>
      <p>
        You may request access to your data, correct it, delete it, or withdraw consent.
        Email {MAIL} from your account address — we respond within 10 business days.
      </p>
      <ul>
        <li>
          <strong>Account deletion:</strong> data is erased within 30 days, backups within
          90 days.
        </li>
        <li>
          <strong>Selective deletion:</strong> you can delete specific data (e.g. AI chat
          history or a particular subscriber&apos;s data) without deleting the account.
        </li>
        <li>
          <strong>Disconnecting a channel:</strong> when Instagram, Telegram or another
          service is disconnected, its access keys are deleted immediately.
        </li>
      </ul>
      <p>
        Step-by-step instructions are on the{' '}
        <a href="/en/data-deletion">Data Deletion page</a>. If you are a subscriber of
        someone else&apos;s bot built with Scriptera, contact the bot owner or email us.
      </p>

      <h2>8. Where data is processed</h2>
      <p>
        Primary data is stored on our servers. Certain operations (e.g. AI requests) may be
        processed by providers outside your country, with legally required safeguards
        applied.
      </p>

      <h2>9. Children</h2>
      <p>
        The Service is intended for persons over 18. If we learn we have collected a
        child&apos;s data, we delete it immediately.
      </p>

      <h2>10. Changes to this policy</h2>
      <p>
        We may update this policy; the new version is published on this page with its date.
        We announce material changes in the Service or by email. Continued use of the
        Service means acceptance of the new version.
      </p>

      <h2>11. Questions</h2>
      <p>For any privacy questions, email {MAIL}.</p>
    </>
  );
}
